import { type ReactElement } from 'react'
import * as S from './cashback.styled'
import image from './assets/image.png'

export function Cashback (): ReactElement {
  return <S.Container>
    <S.Content>
      <S.TextContent>
        <h1>Economize muito com o Cartão de TODOS</h1>
        <p>
          Economize com o Cartão de TODOS!
          <br/>
          Ganhe dinheiro de volta em milhares de parceiros, de forma fácil e rápida. Transforme suas compras em economia.
        </p>
        <p>Receba cashback em farmácias, óticas, postos de gasolina, restaurantes e supermercados. Basta ler a nota fiscal ou comprar pelo app!</p>
      </S.TextContent>
      <figure>
        <img src={image} alt="" />
      </figure>
    </S.Content>
  </S.Container>
}
